import {Component, inject} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {Toast} from 'primeng/toast';
import {LanguageService} from './services/language.service';
import {ConfirmPopup} from "primeng/confirmpopup";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmPopup],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private languageService = inject(LanguageService);

  constructor() {
    this.languageService.initializeTranslateService();
  }
}
